import React from 'react'

function HomeBox5() {
    return (
        <div className='homebox2main' id="home-box2">
            <div className='container'>
                <div className='homebox2'>

                    <div className='homebox2-left'>
                        <img src="/img-smarter.png" alt="hero-img" />
                    </div>

                    <div className='homebox2-right'>
                        <h5>Turn loyalty into a seamless digital experience</h5>
                        <p>Ditch paper punch cards and reward customers the smarter way with easy stamp tracking, visit monitoring, and automated rewards.</p>
                        <h5>Everything included from day one</h5>
                        <p>Enjoy full access to all features during your 15-day trial, including unlimited card designs and customization.Use customer insights, wallet previews, and the Stamper App to create a loyalty experience built for growth.</p>
                        <a href="https://merchant.loyalific.com/login" className='home-box5-btn'>Sign Up</a>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default HomeBox5